//Delete User
export const DELETE_USER ="DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"

//Generate password
export const GENERATE_PASSWORD = "GENERATE_PASSWORD"
export const GENERATE_PASSWORD_SUCCESS = "GENERATE_PASSWORD_SUCCESS"
export const GENERATE_PASSWORD_FAIL = "GENERATE_PASSWORD_FAIL"
